module.exports = __webpack_public_path__ + "static/media/mug.350abfef.svg";